/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */


/**
 * UserBookPreferences Service
 * author: Ujjwal Sana
 * @file UserBookPreferencesService.js
 */

import { BaseService } from '@greenville/framework';

import { USER_BOOK_PREFERENCES_REQUESTED } from '../../../common/constants';

export default class UserBookPreferencesService extends BaseService {
  constructor() {
    super(USER_BOOK_PREFERENCES_REQUESTED);
  }

  fetch(payload) {
    return this.getClient('marinV2').post('/userpreferences/books/fetch', payload);
  }
}
